import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Avatar,
  // Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import MoneyIcon from "@material-ui/icons/Money";

// TODO: make styles global to the project
const useStyles = makeStyles((
  theme // prettier-ignore
) => ({
  root: {
    height: "100%",
    borderRadius: 25,
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56,
  },
  differenceIcon: {
    color: colors.red[900],
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1),
  },
}));

const Courses = ({ className, number, ...rest }) => {
  const classes = useStyles();

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              COURSES
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {number}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <MoneyIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Courses.propTypes = {
  className: PropTypes.string,
};

export default Courses;
